import { render, staticRenderFns } from "./UtilityDetails.vue?vue&type=template&id=b75a83d2&scoped=true"
import script from "./UtilityDetails.vue?vue&type=script&lang=js"
export * from "./UtilityDetails.vue?vue&type=script&lang=js"
import style0 from "./UtilityDetails.vue?vue&type=style&index=0&id=b75a83d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75a83d2",
  null
  
)

export default component.exports